import { useState, useEffect } from 'react'
import Loader from 'react-loaders'
import './index.scss'
import HorizontalScroll from 'react-scroll-horizontal'
import AnimatedLetters from '../AnimatedLetters'
import { Link } from 'react-router-dom'


const Work = () => {
    const child = { width: `300em`, height: `100%`}

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
      return setTimeout(() => {
        setLetterClass('text-animate-hover')
      }, 3000)
    }, [])


    return(
        <>
            <div className='container work-page'>
                <div className='work-container'>
                    <HorizontalScroll>
                        <div className="main bg">
                            <h1>
                                <AnimatedLetters
                                    letterClass={letterClass}
                                    strArray={['T', 'e', 'a', 'm', ' ', 'O', 'r', 'e', 'o', ':', '', 'S', 'o', 'f', 't', 'w', 'a', 'r', 'e', '', 'D', 'e', 'v', ' ', 'I', 'n', 't', 'e', 'r', 'n']}
                                    idx={5}
                                />
                            </h1>
                        </div>
                        <div className="main bg1">
                            <h1>
                                <AnimatedLetters
                                    letterClass={letterClass}
                                    strArray={['D', 'o', 'c', 'k', 'L', 'a', 'n', 'd', 's', '', 'C', 'r', 'e', 'a', 't', 'i', 'v', 'e', ':', '', 'W', 'e', 'b', '', 'D', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r']}
                                    idx={15}
                                />
                            </h1>
                        </div>
                    </HorizontalScroll>
                    <div className='button-container'>
                        <Link to="/resume" className="resume-btn">
                            My Resume/ CV
                        </Link>
                    </div>
                </div>
            </div>
            <Loader type='pacman' />
        </>
        
    )
}

export default Work;